import { render } from "./DividendManualEntryPopup.vue?vue&type=template&id=5401bc85"
import script from "./DividendManualEntryPopup.vue?vue&type=script&lang=js"
export * from "./DividendManualEntryPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__